module.exports = __webpack_public_path__ + "static/media/alyson-b.890a9613.png";